// docs/130 OB3: what the stakes are about, as marks on the board (drawn by game/board/ObjectiveGlow).
import type { Snapshot, Tile } from '../sim/types';

/** What to mark: squares (fixtures, landmarks, destinations) and units (an ally to keep or lead). */
export function objectiveMarks(s: Pick<Snapshot, 'goals' | 'losses' | 'fixtures' | 'units'> | undefined): { tiles: Tile[]; units: number[] } {
  const tiles: Tile[] = [];
  const units: number[] = [];
  if (!s) return { tiles, units };
  const fixture = (id?: number) => (id === undefined ? undefined : (s.fixtures ?? []).find((f) => f.id === id));
  const add = (t: Tile | undefined) => { if (t && !tiles.some((x) => x.x === t.x && x.y === t.y)) tiles.push({ ...t }); };
  for (const g of s.goals?.goals ?? []) {
    switch (g.kind) {
      case 'Work': {
        // done: nothing left to do there
        if ((g.of ?? 0) > 0 && (g.value ?? 0) >= (g.of ?? 0)) break;
        add(fixture(g.fixture)?.tile);
        break;
      }
      case 'Take': {
        const f = fixture(g.fixture);
        // held: the carrier's token says so
        if (f && !f.on) add(f.tile);
        break;
      }
      case 'Deliver': {
        const f = fixture(g.fixture);
        if (f && !f.on) add(f.tile);
        for (const t of g.tiles ?? []) add(t);
        break;
      }
      case 'Hold': case 'Reach':
        for (const t of g.tiles ?? []) add(t);
        break;
      case 'Escort':
        if (g.unit !== undefined && !units.includes(g.unit)) units.push(g.unit);
        for (const t of g.tiles ?? []) add(t);
        break;
      default:
        break;
    }
  }
  for (const l of s.losses ?? []) {
    if (l.kind === 'Dropped' && !units.includes(l.unit)) units.push(l.unit);
  }
  // only those still standing on the board
  const standing = units.filter((id) => (s.units ?? []).some((u) => u.unitId === id && u.hp > 0));
  return { tiles, units: standing };
}
